// _error-wrapper route directory needed so that sidebar still shows with error and notFound views
import { createFileRoute, Outlet } from '@tanstack/react-router'
import NotFound from '@/routes/-NotFound'
import ErrorPage from '@/routes/-ErrorPage'

export const Route = createFileRoute('/$leaid/_error-wrapper')({
  notFoundComponent: NotFound,
  errorComponent: ErrorPage,
  component: () => <Outlet/>,
})
